import FantasyPlayerDetailedStatsModel from "../Models/FantasyPlayerDetailedStatsModel";
import FantasyPlayerStatsModel from "../Models/FantasyPlayerStatsModel";
import FantasyPredictionRequestBody from "../Models/FantasyPredictionRequestBody";
import PlayerStatsMatchModel from "../Models/PlayerStatsMatchModel";

const playerStats: string[] = Object.keys(new PlayerStatsMatchModel());

const labelMap = new Map()
  .set("minutesPlayed", "Minutes Played")
  .set("cleanSheets", "Clean Sheets")
  .set("concededGoals", "Goals Conceded")
  .set("saves", "Saves")
  .set("penaltySaved", "Penalties Saved")
  .set("penaltyCommitted", "Penalties Committed")
  .set("yellowCards", "Yellow Cards")
  .set("redCards", "Red Cards")
  .set("assists", "Assists")
  .set("foulsCommitted", "Fouls Committed")
  .set("ownGoals", "Own Goals")
  .set("goals", "Goals")
  .set("tackles", "Tackles")
  .set("shotsOn", "Shots On Target")
  .set("penaltyGoals", "Penalty Goals")
  .set("penaltyWon", "Penalty Won")
  .set("penaltyMissed", "Penalty Missed")
  .set("penaltySaved", "Penalty Saved")
  .set("penaltyReceived", "Penalty Received")
  .set("shots", "Shots")
  .set("shotsBlocked", "Shots Blocked")
  .set("offsides", "Offsides")
  .set("foulsWon", "Fouls Won")
  .set("tacklesBlocks", "Tackles Blocks")
  .set("tacklesInterceptions", "Tackles Interceptions")
  .set("caughtBall", "Caught Ball")
  .set("passes", "Passes")
  .set("crosses", "Crosses")
  .set("interceptions", "Interceptions")
  .set("keyPasses", "Key Passes")
  .set("passesAccuracy", "Passes Accuracy")
  .set("duels", "Duels")
  .set("duelsWon", "Duels Won")
  .set("dribblesAttempts", "Dribbles Attempts")
  .set("dribblesSuccess", "Dribbles Success")
  .set("dribblesPast", "Dribbles Past");

export default class FantasyFactory {
  public static createFantasyPrediction(
    templateId: string,
    groupId: string,
    playerIds: string[],
    playersRoles: Map<string, string> | null
  ): FantasyPredictionRequestBody {
    const model = new FantasyPredictionRequestBody();

    model.template_id = templateId || null;
    model.group_id = groupId || null;
    model.fixtures =
      playerIds?.map((playerId) => ({
        player_id: playerId,
        match_type: "FOOTBALL",
        market: "PLAYER_PERFORMANCE",
        role: playersRoles?.get(playerId)?.toLocaleUpperCase() || null,
      })) || [];

    return model;
  }

  public static createFantasyPlayerStats(
    detailedStats: FantasyPlayerDetailedStatsModel
  ): FantasyPlayerStatsModel[] {
    return playerStats.map((s) => {
      const model = new FantasyPlayerStatsModel();
      const value = detailedStats.data.reduce(
        (accumulator, currentValue) => accumulator + currentValue.stats[s],
        0
      );

      model.key = s;
      model.label = labelMap.get(s);
      model.value = value;

      return model;
    });
  }
}
